export default __webpack_public_path__ + "static/media/pizzaShop-app.5abb27e6.png";